import pB from "../data/priceBasis.json";
import setDefaultValues from "./setDefaultValues";

export default function getPriceInfo(c, locale) {
  // TODO 1468, felhantering vid felaktiga funktionsanrop
  // - ingen config
  // - ej fullständig konfig
  // - ej förväntade värden på inputs

  // Copy objects to avoid mutation
  const priceBasis = JSON.parse(JSON.stringify(pB));
  const configuration = JSON.parse(JSON.stringify(c));

  // Update confifguration with default values for dimensions
  // where user input has not been set at the moment
  setDefaultValues(configuration);

  // --------------------------------------------
  // CONSERVATORY COSTS
  // --------------------------------------------
  const conservatory = {
    total:
      priceBasis[locale].conservatory[configuration.size][configuration.type][
        configuration.season
      ],
  };
  // --------------------------------------------//

  // --------------------------------------------
  // FOUNDATION COSTS
  // --------------------------------------------
  const foundation =
    priceBasis[locale].foundation[configuration.size][configuration.foundation];

  // Handle exceptions for foundation costs
  if (configuration.constructionSupport === "none") {
    foundation.staff = 0;
    foundation.taxDeductions = 0;
  } else if (configuration.type === "free") {
    // (No tax deductions in Sweden for conservatory type 'free')
    foundation.taxDeductions = 0;
  }

  const foundationTotal =
    foundation.material + foundation.staff + foundation.taxDeductions;

  foundation.total = foundationTotal;
  // --------------------------------------------//

  // --------------------------------------------
  // CONSTRUCTION COSTS
  // --------------------------------------------
  const construction =
    priceBasis[locale].construction[configuration.size][
      configuration.constructionSupport
    ];
  // Handle exception for construction costs
  if (configuration.type === "free") {
    // (No tax deductions in Sweden for conservatory type 'free')
    construction.taxDeductions = 0;
  }

  const construtionTotal = construction.staff + construction.taxDeductions;

  construction.total = construtionTotal;
  // --------------------------------------------//

  // Total cost for entire project
  const total = conservatory.total + foundation.total + construction.total;

  // Cost per month for entire project
  const exactPerMonth = total / priceBasis[locale].other.numberOfMonths;
  const perMonth = Math.ceil(exactPerMonth / 10) * 10;

  const meta = priceBasis[locale].meta;

  // Setup priceInfo with summary of all costs
  const priceInfo = {
    total,
    perMonth,
    conservatory,
    foundation,
    construction,
    meta,
  };

  return priceInfo;

  /* Dummy example of returned priceInfo object
  {
    total: 65000,
    perMonth: 1234,
    conservatory: {
      total: 40000
    },
    foundation: {
      total: 15000,
      material: 15000,
      staff: 0,
      taxDeductions: 0
    },
    construction: {
      total: 0,
      staff: 0,
      taxDeductions: 0
    },
    meta: {
      staffPerHour: 550
    }
  }
  */
}
